import deepmerge from 'deepmerge'; // < 1kb payload overhead when lodash/merge is > 3kb.

function merge(acc, item) {
  if (!item) {
    return acc;
  }

  return deepmerge(acc, item, {
    clone: false // No need to clone deep, it's way faster.

  });
}

export default merge;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/system/esm/merge.js
// module id = 98
// module chunks = 0